import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatDate } from 'helpers/helpers'

// История отметок сотрудника: что присылала камера (приход / уход) и что с этим сделала
// касса. Отвечает на «ухода нет» — видно, что сотрудник дважды отметил приход
function EventsHistory({ show, employee, startDate, endDate, onHide }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [loading, setLoading] = useState(false)

	async function getData() {
		setLoading(true)
		const response = await GET('/users-attendances-events', {
			'user_login': employee.login,
			'start_date': startDate,
			'end_date': endDate,
		}, { loader: true })
		setLoading(false)
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		if (show && employee?.login) getData()
		if (!show) setData([])
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show, employee?.login, startDate, endDate])

	function directionLabel(item) {
		if (item.direction === 'check_in') return <span className="text-success">{t('attendance_event_check_in')}</span>
		if (item.direction === 'check_out') return <span className="text-primary">{t('attendance_event_check_out')}</span>
		return <span className="text-muted">{item.attendance_status ?? '-'}</span>
	}

	return (
		<Modal show={show} animation={false} centered size="lg" onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>
					{t('attendance_events_history')}: {employee?.name}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="text-muted mb-2">
					{formatDate(startDate, 'dd.MM.yyyy')} - {formatDate(endDate, 'dd.MM.yyyy')}
				</div>
				<div className="table-responsive" style={{ 'maxHeight': '60vh' }}>
					<table className="table table-bordered mb-0">
						<thead>
							<tr>
								<th style={{ 'width': '150px' }}>{t('time')}</th>
								<th style={{ 'width': '110px' }}>{t('attendance_event_mark')}</th>
								<th>{t('attendance_event_result')}</th>
							</tr>
						</thead>
						<tbody>
							{data.map((item) => (
								<tr key={item.id}>
									<td>{formatDate(item.event_time, 'dd.MM.yyyy HH:mm:ss')}</td>
									<td>{directionLabel(item)}</td>
									<td className={Number(item.processed) === 1 ? '' : 'text-danger'}>
										{item.process_result}
									</td>
								</tr>
							))}
							{!loading && data.length === 0 &&
								<tr>
									<td colSpan="3" className="text-center text-muted">{t('attendance_events_empty')}</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default EventsHistory
